import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import createPersistedState from "vuex-persistedstate";

const initialState = {
    upload: {
        file: '',
        response: ''
    }
  }

Vue.use(Vuex);

export default new Vuex.Store({
    state: initialState,
    actions,
    mutations,
    getters,
    plugins: [createPersistedState({storage: window.sessionStorage, key: 'fpp'})]
});
